import React from "react";
var PnmacHtmlToNative = function (_a) {
  var color = _a.color,
    _b = _a.size,
    size = _b === void 0 ? 14 : _b,
    value = _a.value,
    onClick = _a.onClick,
    _c = _a.fontFamily,
    fontFamily = _c === void 0 ? 'HalenoirCompactText-Regular' : _c;
  return /*#__PURE__*/React.createElement("div", {
    className: 'htmlToNative',
    onClick: onClick,
    style: {
      color: color,
      fontSize: size,
      fontFamily: fontFamily
    },
    dangerouslySetInnerHTML: {
      __html: value
    }
  });
};
export default PnmacHtmlToNative;